import { render, staticRenderFns } from "./checkInternationalChange.vue?vue&type=template&id=7ffa61f9"
import script from "./checkInternationalChange.vue?vue&type=script&lang=js"
export * from "./checkInternationalChange.vue?vue&type=script&lang=js"
import style0 from "./checkInternationalChange.vue?vue&type=style&index=0&id=7ffa61f9&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports